module.exports = __webpack_public_path__ + "static/Pinwheel-e3517329ea267b469d13e5fcec2e5e57.jpg";